import React from 'react';
import './Loader.scss';


const Loader = ({ isSimple = true }) => {
    return (<span className={isSimple ? "advanced-simpleloader" : '"advanced-loader"'}></span>)
}

export default Loader;